module.exports = __webpack_public_path__ + "media/images/up_arrow-2d8557b11a2eb27359d7d7773d01ce1e.png";